// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import React from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '../context/AuthContext';

// `autorise` : condition supplémentaire sur le compte, quand le rôle PLATEFORME
// ne suffit pas à décider. L'espace client s'ouvre sur `license_role`, qui n'a
// rien à voir avec `role` — deux colonnes distinctes, cf `lib/acces.js`.
const ProtectedRoute = ({ children, roles, autorise }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const [, setLocation] = useLocation();

  React.useEffect(() => {
    if (!loading && !isAuthenticated()) {
      setLocation('/login');
    }
  }, [loading, isAuthenticated, setLocation]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-4xl mb-4">⏳</div>
          <p className="text-gray-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated()) return null;

  // Vérification rôle si prop `roles` fournie, ou condition `autorise`
  if ((roles && !roles.includes(user?.role)) || (autorise && !autorise(user))) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="text-5xl mb-4">🔒</div>
          <h2 className="text-xl font-bold text-gray-800 mb-2">Accès non autorisé</h2>
          <p className="text-gray-500 mb-6">Vous n&apos;avez pas les droits pour accéder à cette page.</p>
          <a href="/dashboard" className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700">Retour au dashboard</a>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedRoute;